// The selected category owns the wizard context. Contacts may supply defaults
// only when they belong to that category; never mix two recipient profiles.
export function recipientGender(menu, contactGender = null) {
  const configured = menu && menu.wizard_decrypt && menu.wizard_decrypt.gender;
  return configured && configured !== "Both" ? configured : contactGender;
}

export function canReuseProfile(menu, profile) {
  if (!menu || !profile) return false;
  const category = profile.ageGroup;
  const label = typeof category === "string" ? category : category && category.label;
  return label === menu.label && !!profile.gender &&
    recipientGender(menu, profile.gender) === profile.gender;
}

export async function profileBelongsToMenu(menu, profile) {
  if (!canReuseProfile(menu, profile)) return false;
  const post = async (path, body) => {
    const response = await fetch(process.env.VUE_APP_URL + path, {
      method: "POST", headers: {"content-type": "application/json"},
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error("Cannot load menu choices");
    return response.json();
  };
  try {
    const [ages, personas, styles] = await Promise.all([
      post("customer/agerange/getAgerange", {type: menu.label}),
      post("customer/persona/getPersonas", {type: menu.label, gender: profile.gender, ch_type: "persona"}),
      post("customer/persona/getPersonas", {type: menu.label, gender: profile.gender, ch_type: "active_lifestyle"}),
    ]);
    const contains = (choices, selected) => Array.isArray(choices) && Array.isArray(selected) &&
      selected.every(value => choices.some(choice => String(choice.id) === String(value.id)));
    return contains(ages.ageranges || (ages.agerange && ages.agerange.ageranges), [profile.ageRange || {}]) &&
      contains(personas.caricatures, profile.persona) && contains(styles.caricatures, profile.activeLifeStyle);
  } catch (_) {
    return false;
  }
}

export function savedWizardProfile(saved) {
  return {ageGroup: saved.menu, gender: saved.gender, ageRange: saved.age,
    persona: saved.personas, activeLifeStyle: saved.active_lifestyles};
}

export function clearRecipientDetails(wizard) {
  for (const field of ["age", "personas", "active_lifestyles", "caricature_trait",
    "relation", "price", "persona_array", "lifestyle_array", "wizard_Details"]) {
    wizard[field] = null;
  }
  for (const step of ["showAge", "showGender", "showPersona", "showStyle",
    "showTrait", "showRelation", "SelectPricerange", "selctContact"]) {
    wizard[step] = false;
  }
}

export async function loadContactDetails(wizard, profile) {
  const menu = wizard.menu;
  const contact = wizard.selected_friend;
  clearRecipientDetails(wizard);
  const reusable = await profileBelongsToMenu(menu, profile);
  if (wizard.menu !== menu || wizard.selected_friend !== contact) return;
  wizard.loader = false;
  wizard.gender = recipientGender(wizard.menu, wizard.selected_friend.gender);
  if (reusable && profile.ageRange &&
      profile.persona != null && profile.activeLifeStyle != null && profile.characterTrait != null) {
    wizard.wizard_Details = profile;
    wizard.selectContact();
  } else if (wizard.gender == null) {
    wizard.addfriendToGender();
  } else {
    wizard.addfriendAgerange();
  }
}
